module.exports = __webpack_public_path__ + "assets/img/reserve-white.9ca2d2a2.svg";